import { toast } from 'react-toastify';
import appApi, {
  CreateAccountingDepositRequest,
} from '../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const createAccountingDepositOperation = async (
  payload: CreateAccountingDepositRequest,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
) => {
  if (!payload.bankAccountId) {
    toast.warn('יש לבחור חשבון בנק');
    return;
  }

  if (!payload.depositDate) {
    toast.warn('יש לבחור תאריך הפקדה');
    return;
  }

  if (!(payload.totalAmount > 0)) {
    toast.warn('סכום ההפקדה חייב להיות חיובי');
    return;
  }

  if (!payload.payments || payload.payments.length < 1) {
    toast.warn('יש לבחור לפחות תשלום אחד');
    return;
  }

  const trimmedNotes = payload.notes?.trim();
  const normalizedNotes =
    trimmedNotes != null && trimmedNotes !== '' ? trimmedNotes : null;

  if (normalizedNotes !== null && normalizedNotes.length > 2000) {
    toast.warn('הערות מוגבלות ל-2000 תווים');
    return;
  }

  try {
    setLoading(true);

    const res = await appApi.createAccountingDeposit({
      bankAccountId: payload.bankAccountId,
      depositDate: payload.depositDate,
      totalAmount: payload.totalAmount,
      notes: normalizedNotes,
      payments: payload.payments,
    });

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    toast.success('ההפקדה נוצרה בהצלחה');
    setLoading(false);
    onSuccess();
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
